export default __webpack_public_path__ + "static/media/Logo Icon.757545a3.svg";